import { useEffect } from 'react';

const useDebounceWithFunction = (callback: () => void, value: string, delay: number) => {
  useEffect(
    () => {
      const typingTimer = setTimeout(callback, delay);

      return () => clearTimeout(typingTimer);
    },
    [delay, value],
  );
};

export default useDebounceWithFunction;
